import { Injectable, Inject } from '@angular/core';
import { GENERATOR_ENV_TOKEN, GeneratorEnv } from 'src/app/web-generator/generator-env-token';
import { HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CommonHttpClientService } from './common-http-client.service';
import { NewUploadSetting } from '../entity/upload-file';

@Injectable({
  providedIn: 'root'
})
export class UploadService {

  constructor(
    @Inject(GENERATOR_ENV_TOKEN) private generatorEnv: GeneratorEnv,
    private http: CommonHttpClientService
  ) { }

  getUploadSetting(type: string): Observable<NewUploadSetting> {
    return this.http.get<NewUploadSetting>(`${this.generatorEnv.apiHost}/api/file/upload`, {
      // tslint:disable-next-line: object-literal-key-quotes
      headers: { 'access_token': this.generatorEnv.commonToken },
      params: { type: (type) }
    });
  }

  uploadFile2Server = (type: string, formData: FormData): Observable<HttpEvent<any>> => {
    return this.http.post(`${this.generatorEnv.apiHost}/api/file/upload`, formData, {
      // tslint:disable-next-line: object-literal-key-quotes
      headers: { 'access_token': this.generatorEnv.commonToken },
      params: { type: (type) },
      reportProgress: true,
      observe: 'events'
    });
  }

  cropImg2Server(cropDetail: any): Observable<any> {
    return this.http.post(`${this.generatorEnv.apiHost}/api/common/clipped`, cropDetail,
      { // tslint:disable-next-line: object-literal-key-quotes
        headers: { 'access_token' : this.generatorEnv.commonToken}
      }
    );
  }
}
